class TagsFilter extends HTMLElement {
    constructor() {
        super()
        this.tagButtons = null
        this.allTopicsButton = null
    }

    connectedCallback() {
        this.initialize()
    }

    initialize() {
        this.tagButtons = this.querySelectorAll("[data-blog-tag]")
        this.allTopicsButton = this.querySelector("[data-blog-tag='all']")

        this.setupEventListeners()
        this.setInitialActiveState()
    }

    setupEventListeners() {
        this.tagButtons.forEach((button) => {
            button.addEventListener("click", () => this.handleTagClick(button))
        })
    }

    handleTagClick(button) {
        const selectedTag = button.getAttribute("data-blog-tag")
        const baseURL = this.getBaseURL()

        if (selectedTag === "all") {
            this.updateURL(baseURL)
            this.updateActiveButton(this.allTopicsButton)
        } else {
            const newPath = `${baseURL}/tagged/${selectedTag}`
            this.updateURL(newPath)
            this.updateActiveButton(button)
        }
    }

    getCurrentTagFromURL() {
        const path = window.location.pathname
        if (path.includes("/tagged/")) {
            const taggedPart = path.split("/tagged/")[1]
            return taggedPart.split("+")[0]
        }
        return null
    }

    getBaseURL() {
        const currentPath = window.location.pathname
        const basePath = currentPath.split("/tagged")[0]
        return window.location.origin + basePath
    }

    updateURL(newPath) {
        window.location.href = newPath
    }

    updateActiveButton(activeButton) {
        this.tagButtons.forEach((button) =>
            button.classList.remove("tag-active")
        )
        activeButton.classList.add("tag-active")
    }

    setInitialActiveState() {
        const currentTag = this.getCurrentTagFromURL()

        if (currentTag) {
            const activeButton = this.querySelector(
                `[data-blog-tag="${currentTag}"]`
            )
            if (activeButton) {
                activeButton.classList.add("tag-active")
            } else {
                this.allTopicsButton.classList.add("tag-active")
            }
        } else {
            this.allTopicsButton.classList.add("tag-active")
        }
    }
}

window.customElements.define("tags-filter", TagsFilter)

class BlogSearch extends HTMLElement {
    connectedCallback() {
        this.setupEventListeners()
    }

    setupEventListeners() {
        const searchInput = this.querySelector("#blogSearchInput")
        searchInput.addEventListener("input", () => {
            console.log("input")
            this.searchBlogPosts()
        })
    }

    searchBlogPosts() {
        const input = this.querySelector("#blogSearchInput")
        const resultList = this.querySelector("#search-results-list")
        const blogList = this.querySelector(".blog-list")
        const grid = this.querySelector("#blog-posts-grid")
        const items = grid.querySelectorAll(".blog-post-item")

        if (!input.value.trim()) {
            resultList.style.display = "none"
            blogList.style.display = "block"
            return
        }

        const filter = input.value.toUpperCase()
        resultList.style.display = "block"
        blogList.style.display = "none"

        Array.from(items).forEach((item) => {
            console.log(item)
            const title = item.querySelector(".blog-title")
            const txtValue = title?.textContent || title?.innerText || ""
            item.style.display = txtValue.toUpperCase().includes(filter)
                ? ""
                : "none"
        })
    }
}

window.customElements.define("blog-search", BlogSearch)
